module.exports = __webpack_public_path__ + "img/4.70c3a234.webp";